import { FC } from "react";

const Spinner: FC = () => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="flex items-center justify-center space-x-1 text-sm text-gray-700">
        <div className="w-16">
          <img alt="loader" src="/assets/images/loading-bounce.gif" />
        </div>
      </div>
    </div>
  );
};
export default Spinner;
